// extracted by mini-css-extract-plugin
export default {"backButton":"PlatformTypePage_backButton__Nwxit","platformTypes":"PlatformTypePage_platformTypes__HhAYM","footer":"PlatformTypePage_footer__ZBEz4"};